import React, { Component } from 'react';
import HOC from "./HOC";

class BlankPage extends Component {
    state = {
        
    }

    componentWillMount(){
    }

    // componentWillUnmount(){
    // }

    componentDidMount(){

    }

    render() {
        return (
            <>
            {
                <div className={( this.state.buscadorMobile )+" boxBuscar mb-w100 d-flex flex-column flex-justify-between w100"}>
                <div className="banner banner-white d-flex justify-content-center mb-display-none">
                    <div className="boxBanner boxBanner-white d-flex justify-content-between align-items-center">
                        <div className="tituloBanner">
                            <p><b>Usted No tiene permisos para este Aplicativo =(</b></p>
                        </div>
                    </div>
                </div>
                <div className="display-none">
                   <p><b>Pagina En Blanco </b></p>
                </div>                         
                 </div>
            }                
            </>
        );
    }
}

export default HOC(BlankPage);